import { initialCommonState } from 'redux/initialState';
import { status } from 'constants/general';

import commonActionTypes from './action-types';

const commonReducer = (state = initialCommonState, { type, payload }) => {
  switch (type) {
    case commonActionTypes.SET_CONTEXT:
      return {
        ...state,
        context: payload,
      };

    case commonActionTypes.FETCH_CONFIGURATIONS:
      return {
        ...state,
        configurations: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        configurations: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_CONFIGURATIONS_FAIL:
      return {
        ...state,
        configurations: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default commonReducer;
